import React from 'react';

const Map = () => <div>Map Page</div>;

export default Map; 